import { render } from "./App.vue?vue&type=template&id=286c8dcc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=286c8dcc&lang=scss"

import exportComponent from "/Users/gigi/Documents/micowell/dalwa/xmai_official_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__